import { Request } from '../../components/funcs/BASES/Request'

import {
  GETALL_SUCCESS,
  GETONE_SUCCESS,
  CREATE_SUCCESS,
  UPDATE_SUCCESS,
  TOGGLE_SUCCESS,
} from '../types/BeslenmeType'


export const GetAllSuccess = data => ({ type: GETALL_SUCCESS, payload: data })
export const GetOneSuccess = data => ({ type: GETONE_SUCCESS, payload: data })
export const CreateSuccess = data => ({ type: CREATE_SUCCESS, payload: data })
export const UpdateSuccess = data => ({ type: UPDATE_SUCCESS, payload: data })
export const ToggleSuccess = data => ({ type: TOGGLE_SUCCESS, payload: data })


export const GetAll = (Data, before, after, onSuccess, onError) => dispatch => {
  Request('GET', '/Auth/BeslenmeType', Data,
    data => { dispatch(GetAllSuccess(data)) },
    () => {},
    before, after, onSuccess, onError,
    true, false,
  )
}

export const GetOne = (Data, before, after, onSuccess, onError) => dispatch => {
  Request('GET', '/Auth/BeslenmeType', Data,
    data => { dispatch(GetOneSuccess(data)) },
    () => {},
    before, after, onSuccess, onError,
    true, false,
  )
}

export const Create = (Data, before, after, onSuccess, onError) => dispatch => {
  Request('POST', '/Auth/BeslenmeType', Data,
    data => { dispatch(CreateSuccess(data)) },
    () => {},
    before, after, onSuccess, onError,
    true, false,
  )
}

export const Update = (Data, before, after, onSuccess, onError) => dispatch => {
  Request('PUT', '/Auth/BeslenmeType', Data,
    data => { dispatch(UpdateSuccess(data)) },
    () => {},
    before, after, onSuccess, onError,
    true, false,
  )
}

export const ToggleActive = (Data, before, after, onSuccess, onError) => dispatch => {
  Request('PATCH', '/Auth/BeslenmeType', Data,
    data => { dispatch(ToggleSuccess(data)) },
    () => {},
    before, after, onSuccess, onError,
    true, false,
  )
}
